import React from 'react';
import '../PickSeatManually.scss';
import { Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';
import PriceItem from 'Components/Shared/PriceItem/PriceItem';

interface IProps {
  seat: Julius.Website.SectionSeatViewModel;
  posX: number;
  posY: number;
  radius: number;
  isSelected: boolean;
  isHovered: boolean;
  isAvailable: boolean;
  priceCategory?: Julius.Website.PriceCategoryViewModel;
  onClick: (seat: Julius.Website.SectionSeatViewModel) => void;
  onMouseEnter: (seat: Julius.Website.SectionSeatViewModel) => void;
  onMouseLeave: () => void;
}

const Seat: React.SFC<IProps> = ({
  seat,
  seat: {
    status,
    rowNbr,
    seatNbr,
    seatID,
  },
  posX,
  posY,
  radius,
  isSelected,
  isHovered,
  isAvailable,
  priceCategory,
  onClick,
  onMouseEnter,
  onMouseLeave,
}) => {

  var tooltip
  var color
if (status === 1) {
   color = isSelected ? '#000' : status !== 1 ? '#ccc' :
    priceCategory ? priceCategory.color : '#ccc';

   tooltip = priceCategory && (status === 1 || isSelected) ? (
    <div>
      <FormattedMessage 
        id='order.seatpicker.tooltip'
        defaultMessage=''
        values={ { rowNbr, seatNbr, price: priceCategory.price } }
      />
    </div>
  ) : undefined;


  }
   else {
         color =  '#ccc';
    
       tooltip = 
        <div>
          { <FormattedMessage 
            id='order.seatpicker.notAvailable'
            defaultMessage='' 
          /> }

        </div>

      }

      const style = isSelected
      ? 'seat selected'
      : isAvailable
        ? isHovered
          ? 'seat hover'
          : 'seat'
        : undefined;

  return (
    <Tooltip placement="top" title={ tooltip }>
      <circle 
        className={ style }
        id={ `${ seatID }` } 
        key={ seatID } 
        cx={ posX } 
        cy={ posY } 
        r={ radius } 
        fill={ color }  
        onClick={ () => onClick(seat) }
        onMouseOver={ () => { onMouseEnter(seat) } }
        onMouseLeave={ () => { onMouseLeave() } }
      />
    </Tooltip>
  );
}

export default Seat;


// WEBPACK FOOTER //
// ./src/components/PickSeatManually/InnerSection/Seat.tsx